import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import { isLoggedIn, getPersistedRefreshToken, refreshLogin } from '../api/auth'

// 安装路由
Vue.use(VueRouter);

// 配置导出路由
const router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "Guest",
    path: '/guest',
    component: () => import("../view/GuestChat")
  },
  {
    // 电话会销独立页(不集成在聊天内): 不在白名单,未登录自动跳登录页
    name: "Telesales",
    path: '/telesales',
    component: () => import("../view/Telesales")
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      },
      {
        name: "Finance",
        path: "/home/finance",
        component: () => import("../view/Finance"),
      },
      {
        name: "KqReport",
        path: "/home/kq-report",
        component: () => import("../view/KqReport"),
      },
      {
        name: "KqStats",
        path: "/home/kq-stats",
        component: () => import("../view/KqStats"),
      },
      {
        name: "ReportShare",
        path: "/home/report-share",
        component: () => import("../view/ReportShare"),
      },
      {
        name: "MyCustomer",
        path: "/home/my-customer",
        component: () => import("../view/MyCustomer"),
      },
      {
        name: "QuoteBoard",
        path: "/home/quote",
        component: () => import("../view/QuoteBoard"),
      }
    ]
  }
  ]

});

const whiteList = ['/login', '/login/demo', '/register', '/password/reset', '/guest'];

router.beforeEach(async (to, from, next) => {
  if (whiteList.includes(to.path) || isLoggedIn()) {
    return next();
  }
  // 浏览器已有登录账号(localStorage 持久化 refreshToken): 静默续期复用现有登录态直接放行,
  // 不跳交互式登录页。避免独立页(如 /telesales)在新标签页重新登录顶掉正在使用的聊天页会话。
  // 后端 /refreshToken 只重签发无状态 JWT,不吊销旧 token、不踢 WebSocket,故不影响其它标签页。
  if (getPersistedRefreshToken()) {
    try {
      await refreshLogin();
      return next();
    } catch (e) {
      // 续期失败(令牌过期/被清),继续落到登录页
    }
  }
  // 带上原目标地址: 登录成功后回跳(独立页链接分享场景)
  next({ path: '/login', query: { redirect: to.fullPath } });
});


export default router;